// Please use alphabetical order for end endpoints and hooks being exported

import {
    accountDepartmentAssignmentTypes,
    accountRoleTypes,
    clients,
    clientSettings,
    clientStatuses,
    clientBusinessChannels,
    clientIntegrationTypes,
    clientOrderIssues,
    clientStatusChangedNotificationConfig,
    clientTradingServiceConstants,
    contractorBlocklistReasons,
    contractorServiceTypes,
    contractorStatuses,
    contractorJobTypeEligibilityTypes,
    countries,
    directedInvoiceTypes,
    documentTradeTypes,
    financialInvoiceLineOfBusinesses,
    financialSyncQueueModels,
    financialSyncQueueStatuses,
    financialBillingStatuses,
    financialPaymentStatuses,
    financialStatuses,
    financialSyncQueueResolveReasons,
    financialTerms,
    getActiveAssetConfigurations,
    getAllAssetConfigurations,
    opsAccounts,
    orderCancelReasons,
    orderContactTypes,
    orderFulfillmentTypes,
    orderHoldReasons,
    orderNotificationTypes,
    orderPriorityTypes,
    orderStatuses,
    projectContactTypes,
    projectHoldReasonTypes,
    propertyStatuses,
    propertyTypes,
    quoteIssues,
    quoteReasons,
    quoteStatuses,
    quoteReopenReasons,
    quoteRequestRevisionTypes,
    quoteRejectTypes,
    quoteTypes,
    savedOrderVisibilityTypes,
    states,
    timezones,
    workOrderContactTypes,
    workOrderIssueRejectedTypes,
    workOrderIssues,
    workOrderPhotoTypes,
    workOrderVideoTypes,
    workOrderPriorityTypes,
    workOrderRequirementApprovalReasons,
    workOrderStatuses,
    workOrderTypes,
    productAttributeTypes,
    folderAttachmentTypes,
    adjustmentTypes,
    lineItemAdjustmentReasonTypes,
    lineItemStatuses,
    laborWarrantyExtensionStatuses,
    contractorClients,
    orderLogisticsTypes,
    orderFulfillmentMethods,
    contractorFileTypes,
    orderIssues,
    contractorTeamMemberFileTypes,
    contractorTeamMemberNotifications,
    contractorTeamMemberTitles,
    accountPreferenceTypes,
    orderTypes,
    priceBookTypes,
    accountDepartmentTypes,
    assetManufacturers,
    assetPhotoTypes,
    assetConfigurationCategories,
    vendorsApproved,
    projectStatuses,
    projectScopeTypes,
    managedProductCategories,
    productCategories,
    contractorQualificationTypes,
    projectAttachmentTypes,
    propertyAttachmentTypes,
    templateTypes,
    financialSalesOrderLineOfBusinesses,
    documentTypes,
    orderManualVendorDetailTypes,
    orderReturnReasons,
    orderReturnStatuses,
    orderReturnCancelReasons,
    orderReturnAttachmentTypes,
    orderReturnContactTypes,
    assetUntaggableReasons,
    projectTypes,
    workOrderPdfTypes,
    draftStatuses,
    vendorsAll,
    assetStatuses,
    usStates,
    warrantyContactTypes,
    warrantyOwnerTypes,
    warrantyOwnerInstallTypes,
    warrantyRegistrationStatuses,
    workOrderContactPreferenceTypes,
    unitOfMeasures,
    managedVendorDistributionTypes,
    managedVendorIntegrationTypes,
    managedProductAttributeTypes,
    managedProductPricingTypes,
    managedVendorStatuses,
    managedVendorTypes,
    vendorManufacturers,
    assetRetirementReasons,
    accountRoles,
    quotePdfTypes,
    contractorExternalCertifications,
    contractorInternalCertifications,
    contractorCredentials,
    contractorDispatchRuleTypes,
    clientFreightTypes,
    currencies,
    projects,
    accountTypes,
    ticketProviders,
    assetRecommendationTypes,
    assetRepairReasons,
    lhsRiskTypes,
    tsmRegions,
    workOrderReassignReasons,
    workOrderCheckInCheckOutReasons,
    workOrderUnassignReasons,
    workOrderRescheduleReasons,
    getUserAndGroupMentionslist,
} from 'common/services/MetaService';
import { getClientSettingById } from 'common/services/ClientService';
import * as logger from 'common/utils/Logger';
import {
    childClientAccessEnabled,
    getAccount,
    isClientAccount,
    isMotiliAccount,
} from 'common/services/AuthService';
import {
    getChildClientCompanies,
    getClientCompany,
} from 'client/services/ClientCompanyService';
import { AssetConfiguration } from 'common/types/requirements';
import { createRTKError } from 'common/stores/redux/utils';
import emptyApi from 'common/stores/redux/baseApi';

import {
    AccountDepartmentAssignmentTypeAPI,
    AccountDepartmentTypeAPI,
    AccountRoleAPI,
    AccountPreferenceTypeAPI,
    AccountRoleTypeAPI,
    AccountTypeAPI,
    AssetConfigurationCategoryAPI,
    AssetManufacturerAPI,
    AssetPhotoTypeAPI,
    AssetRecommendationTypeAPI,
    AssetRepairReasonAPI,
    AssetRetirementReasonAPI,
    AssetStatusAPI,
    AssetUntaggableReasonAPI,
    ClientAPI,
    ClientBusinessChannelAPI,
    ClientFreightTypeAPI,
    ClientIntegrationTypeAPI,
    ClientTradingServiceConstantsAPI,
    ClientOrderIssueAPI,
    ClientSettingAPI,
    ClientStatus,
    ClientStatusChangedNotificationConfigAPI,
    ContractorBlocklistReasonAPI,
    ContractorExternalCertificationAPI,
    ContractorInternalCertificationAPI,
    ContractorClientAPI,
    ContractorCredentialAPI,
    ContractorFileTypeAPI,
    ContractorQualificationTypeAPI,
    ContractorServiceTypeAPI,
    ContractorStatus,
    ContractorTeamMemberFileTypeAPI,
    ContractorTeamMemberNotificationAPI,
    ContractorTeamMemberTitleAPI,
    contractorJobTypeEligibilityTypeAPI,
    CountryAPI,
    CurrencyAPI,
    DirectedInvoiceTypesAPI,
    DocumentTradeTypeAPI,
    DocumentTypeAPI,
    DraftStatusAPI,
    FinancialInvoiceLineOfBusinessesAPI,
    FinancialSalesOrderLineOfBusinessesAPI,
    FinancialStatusAPI,
    FinancialSyncQueueModelAPI,
    FinancialSyncQueueResolveReasonsAPI,
    FinancialSyncQueueStatusAPI,
    FinancialTermAPI,
    FolderAttachmentTypeAPI,
    AdjustmentTypeAPI,
    LaborWarrantyExtensionStatusesAPI,
    ManagedProductAttributeTypeAPI,
    ManagedProductCategoryAPI,
    ManagedProductPricingTypeAPI,
    ManagedVendorDistributionTypeAPI,
    ManagedVendorIntegrationTypeAPI,
    ManagedVendorStatusAPI,
    ManagedVendorTypeAPI,
    OpsAccountAPI,
    OrderContactTypeAPI,
    orderFulfillmentMethodAPI,
    OrderFulfillmentTypeAPI,
    OrderIssueAPI,
    OrderLogisticsTypeAPI,
    OrderNotificationTypeAPI,
    OrderManualVendorDetailTypesApi,
    OrderReturnCancelReasonApi,
    OrderReturnAttachmentTypeApi,
    OrderReturnContactTypeApi,
    OrderReturnReasonApi,
    OrderReturnStatusApi,
    OrderStatusAPI,
    OrderTypeAPI,
    ProductAttributeTypeAPI,
    ProductCategoryAPI,
    ProjectAPI,
    ProjectAttachmentTypeAPI,
    ProjectContactTypeAPI,
    ProjectScopeTypeAPI,
    ProjectStatusAPI,
    ProjectTypeAPI,
    PropertyAttachmentTypeAPI,
    PropertyStatusAPI,
    PropertyTypeAPI,
    QuoteIssueAPI,
    QuotePDFTypeAPI,
    QuoteReasonsAPI,
    QuoteReopenReasonsAPI,
    QuoteRequestRevisionTypeAPI,
    QuoteRejectTypeAPI,
    QuoteTypeAPI,
    SavedOrderVisibilityTypeAPI,
    StateAPI,
    TemplateTypeAPI,
    TicketProviderAPI,
    UnitsofMeasureAPI,
    VendorAPI,
    WarrantyContactTypeAPI,
    WarrantyOwnerTypeAPI,
    WarrantyOwnerInstallTypeAPI,
    WarrantyRegistrationStatusesAPI,
    WorkOrderContactPreferenceTypeAPI,
    WorkOrderContactTypeAPI,
    WorkOrderIssueAPI,
    WorkOrderIssueRejectedTypeAPI,
    WorkOrderPDFTypeAPI,
    WorkOrderPhotoTypeAPI,
    WorkOrderPriorityTypeAPI,
    WorkOrderRequirementApprovalReasonAPI,
    WorkOrderStatusAPI,
    WorkOrderTypeAPI,
    LineItemAdjustmentReasonTypeAPI,
    ProjectHoldReasonTypeAPI,
    QuoteStatusAPI,
    LHSRiskType,
    WorkOrderReassignmentReasonAPI,
    WorkOrderCheckInCheckOutReasonTypeAPI,
    WorkOrderUnassignReasonAPI,
    WorkOrderRescheduleReasonAPI,
    PriceBookTypesAPI,
    TimezoneAPI,
    LineItemStatusesAPI,
    ClientSettingByIdAPI,
    ClientSettingByIdParams,
    UserMention,
    ContractorDispatchRuleTypesAPI,
    OrderPriorityTypeAPI,
    TSM_Regions_API,
} from 'common/stores/redux/MetaStore/MetaStoreApi.types';

const apiWithTag = emptyApi.enhanceEndpoints({
    addTagTypes: [
        'accountDepartmentAssignmentTypes',
        'accountDepartmentTypes',
        'accountPreferenceTypes',
        'accountRoles',
        'accountRoleTypes',
        'accountTypes',
        'activeAssetConfigurations',
        'assetConfigurations',
        'assetConfigurationCategories',
        'assetManufacturers',
        'assetPhotoTypes',
        'assetRetirementReasons',
        'assetStatuses',
        'assetUntaggableReasons',
        'clientBusinessChannels',
        'clientFreightTypes',
        'clientIntegrationTypes',
        'clientTradingServiceConstants',
        'clientOrderIssues',
        'clients',
        'clientSettings',
        'clientSettingById',
        'clientStatusChangedNotificationConfig',
        'clientStatuses',
        'contractorBlocklistReasons',
        'contractorExternalCertifications',
        'contractorInternalCertifications',
        'contractorClients',
        'contractorCredentials',
        'contractorDispatchRuleTypes',
        'contractorFileTypes',
        'contractorQualificationTypes',
        'contractorServiceTypes',
        'contractorStatuses',
        'contractorTeamMemberFileTypes',
        'contractorTeamMemberNotifications',
        'contractorTeamMemberTitles',
        'contractorJobTypeEligibilityTypes',
        'countries',
        'currencies',
        'directedInvoiceTypes',
        'documentTradeTypes',
        'documentTypes',
        'draftStatuses',
        'financialBillingStatuses',
        'financialInvoiceLineOfBusinesses',
        'financialPaymentStatuses',
        'financialSalesOrderLineOfBusinesses',
        'financialStatuses',
        'financialSyncQueueModels',
        'financialSyncQueueResolveReasons',
        'financialSyncQueueStatuses',
        'financialTerms',
        'folderAttachmentTypes',
        'adjustmentTypes',
        'lineItemAdjustmentReasonTypes',
        'lineItemStatuses',
        'laborWarrantyExtensionStatuses',
        'managedProductAttributeTypes',
        'managedProductCategories',
        'managedProductPricingTypes',
        'managedVendorDistributionTypes',
        'managedVendorIntegrationTypes',
        'managedVendorStatuses',
        'managedVendorTypes',
        'opsAccounts',
        'orderCancelReasons',
        'orderContactTypes',
        'orderFulfillmentMethods',
        'orderFulfillmentTypes',
        'orderHoldReasons',
        'orderIssues',
        'orderLogisticsTypes',
        'orderNotificationTypes',
        'orderManualVendorDetailTypes',
        'orderReturnCancelReasons',
        'orderReturnAttachmentTypes',
        'orderReturnContactTypes',
        'orderReturnReasons',
        'orderReturnStatuses',
        'orderPriorityTypes',
        'orderStatuses',
        'orderTypes',
        'priceBookTypes',
        'productAttributeTypes',
        'productCategories',
        'projectAttachmentTypes',
        'projectContactTypes',
        'projectHoldReasonTypes',
        'projects',
        'projectScopeTypes',
        'projectStatuses',
        'projectTypes',
        'propertyAttachmentTypes',
        'propertyStatuses',
        'propertyTypes',
        'quoteIssues',
        'quotePdfTypes',
        'quoteReasons',
        'quoteReopenReasons',
        'quoteRequestRevisionTypes',
        'quoteRejectTypes',
        'quoteStatuses',
        'quoteTypes',
        'savedOrderVisibilityTypes',
        'states',
        'templateTypes',
        'ticketProviders',
        'timezones',
        'tsmRegions',
        'unitOfMeasures',
        'usStates',
        'vendorManufacturers',
        'vendorsAll',
        'vendorsApproved',
        'warrantyContactTypes',
        'warrantyOwnerTypes',
        'warrantyOwnerInstallTypes',
        'warrantyRegistrationStatuses',
        'workOrderCheckInCheckOutReasons',
        'workOrderContactPreferenceTypes',
        'workOrderContactTypes',
        'workOrderIssueRejectedTypes',
        'workOrderIssues',
        'workOrderPdfTypes',
        'workOrderPhotoTypes',
        'workOrderVideoTypes',
        'workOrderPriorityTypes',
        'workOrderRequirementApprovalReasons',
        'workOrderStatuses',
        'workOrderTypes',
        'assetRecommendationTypes',
        'assetRepairReasons',
        'lhsRiskTypes',
        'workOrderReassignReasons',
        'workOrderUnassignReasons',
        'workOrderRescheduleReasons',
    ],
});

const api = apiWithTag.injectEndpoints({
    endpoints: build => ({
        accountDepartmentAssignmentTypes: build.query<
            AccountDepartmentAssignmentTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await accountDepartmentAssignmentTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['accountDepartmentAssignmentTypes'],
        }),
        accountDepartmentTypes: build.query<AccountDepartmentTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await accountDepartmentTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['accountDepartmentTypes'],
        }),
        accountPreferenceTypes: build.query<AccountPreferenceTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await accountPreferenceTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['accountPreferenceTypes'],
        }),
        accountRoles: build.query<AccountRoleAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await accountRoles();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['accountRoles'],
        }),
        accountRoleTypes: build.query<AccountRoleTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await accountRoleTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['accountRoleTypes'],
        }),
        activeAssetConfigurations: build.query<AssetConfiguration[], void>({
            queryFn: async () => {
                try {
                    const data = await getActiveAssetConfigurations();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['activeAssetConfigurations'],
        }),
        assetConfigurations: build.query<AssetConfiguration[], void>({
            queryFn: async () => {
                try {
                    const data = await getAllAssetConfigurations();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['assetConfigurations'],
        }),
        assetConfigurationCategories: build.query<
            AssetConfigurationCategoryAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await assetConfigurationCategories();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['assetConfigurationCategories'],
        }),
        assetManufacturers: build.query<AssetManufacturerAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await assetManufacturers();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['assetManufacturers'],
        }),
        assetPhotoTypes: build.query<AssetPhotoTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await assetPhotoTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['assetPhotoTypes'],
        }),
        assetRetirementReasons: build.query<AssetRetirementReasonAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await assetRetirementReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['assetRetirementReasons'],
        }),
        assetStatuses: build.query<AssetStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await assetStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['assetStatuses'],
        }),
        accountTypes: build.query<AccountTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await accountTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['accountTypes'],
        }),
        assetRecommendationTypes: build.query<
            AssetRecommendationTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await assetRecommendationTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['assetRecommendationTypes'],
        }),
        assetRepairReasons: build.query<AssetRepairReasonAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await assetRepairReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['assetRepairReasons'],
        }),
        assetUntaggableReasons: build.query<AssetUntaggableReasonAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await assetUntaggableReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['assetUntaggableReasons'],
        }),
        clients: build.query<ClientAPI[], void>({
            queryFn: async () => {
                try {
                    let data = [];
                    if (isClientAccount()) {
                        const account: {
                            clientTeam: {
                                clientId: number;
                            };
                        } = getAccount();

                        const childClientAccess =
                            childClientAccessEnabled(account);

                        if (childClientAccess) {
                            data = await getChildClientCompanies(account);
                        } else {
                            const client = await getClientCompany(
                                account.clientTeam.clientId
                            );
                            data = [client];
                        }
                    }
                    if (isMotiliAccount()) {
                        data = await clients();
                    }
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clients'],
        }),
        clientBusinessChannels: build.query<ClientBusinessChannelAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await clientBusinessChannels();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clientBusinessChannels'],
        }),
        clientFreightTypes: build.query<ClientFreightTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await clientFreightTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clientFreightTypes'],
        }),
        clientIntegrationTypes: build.query<ClientIntegrationTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await clientIntegrationTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clientIntegrationTypes'],
        }),
        clientOrderIssues: build.query<ClientOrderIssueAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await clientOrderIssues();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clientOrderIssues'],
        }),
        clientSettings: build.query<ClientSettingAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await clientSettings();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clientSettings'],
        }),
        clientSettingById: build.query<
            ClientSettingByIdAPI,
            ClientSettingByIdParams
        >({
            queryFn: async ({ clientId, settingId }) => {
                try {
                    const data = await getClientSettingById(
                        clientId,
                        settingId
                    );
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clientSettingById'],
        }),
        clientTradingServiceConstants: build.query<
            ClientTradingServiceConstantsAPI,
            void
        >({
            queryFn: async () => {
                try {
                    const data = await clientTradingServiceConstants();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clientTradingServiceConstants'],
        }),
        clientStatusChangedNotificationConfig: build.query<
            ClientStatusChangedNotificationConfigAPI,
            void
        >({
            queryFn: async () => {
                try {
                    const data = await clientStatusChangedNotificationConfig();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clientStatusChangedNotificationConfig'],
        }),
        clientStatuses: build.query<ClientStatus[], void>({
            queryFn: async () => {
                try {
                    const data = await clientStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['clientStatuses'],
        }),
        contractorBlocklistReasons: build.query<
            ContractorBlocklistReasonAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await contractorBlocklistReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorBlocklistReasons'],
        }),
        contractorExternalCertifications: build.query<
            ContractorExternalCertificationAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await contractorExternalCertifications();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorExternalCertifications'],
        }),
        contractorInternalCertifications: build.query<
            ContractorInternalCertificationAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await contractorInternalCertifications();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorInternalCertifications'],
        }),
        contractorCredentials: build.query<ContractorCredentialAPI, void>({
            queryFn: async () => {
                try {
                    const data = await contractorCredentials();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorCredentials'],
        }),
        contractorDispatchRuleTypes: build.query<
            ContractorDispatchRuleTypesAPI,
            void
        >({
            queryFn: async () => {
                try {
                    const data = await contractorDispatchRuleTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorDispatchRuleTypes'],
        }),
        contractorClients: build.query<ContractorClientAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await contractorClients();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorClients'],
        }),
        contractorFileTypes: build.query<ContractorFileTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await contractorFileTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorFileTypes'],
        }),
        contractorQualificationTypes: build.query<
            ContractorQualificationTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await contractorQualificationTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorQualificationTypes'],
        }),
        contractorServiceTypes: build.query<ContractorServiceTypeAPI, void>({
            queryFn: async () => {
                try {
                    const data = await contractorServiceTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorServiceTypes'],
        }),
        contractorStatuses: build.query<ContractorStatus[], void>({
            queryFn: async () => {
                try {
                    const data = await contractorStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorStatuses'],
        }),
        contractorTeamMemberFileTypes: build.query<
            ContractorTeamMemberFileTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await contractorTeamMemberFileTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorTeamMemberFileTypes'],
        }),
        contractorTeamMemberNotifications: build.query<
            ContractorTeamMemberNotificationAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await contractorTeamMemberNotifications();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorTeamMemberNotifications'],
        }),
        contractorTeamMemberTitles: build.query<
            ContractorTeamMemberTitleAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await contractorTeamMemberTitles();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorTeamMemberTitles'],
        }),
        contractorJobTypeEligibilityTypes: build.query<
            contractorJobTypeEligibilityTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await contractorJobTypeEligibilityTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['contractorJobTypeEligibilityTypes'],
        }),
        countries: build.query<CountryAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await countries();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['countries'],
        }),
        currencies: build.query<CurrencyAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await currencies();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['currencies'],
        }),
        directedInvoiceTypes: build.query<DirectedInvoiceTypesAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await directedInvoiceTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['directedInvoiceTypes'],
        }),
        documentTradeTypes: build.query<DocumentTradeTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await documentTradeTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['documentTradeTypes'],
        }),
        documentTypes: build.query<DocumentTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await documentTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['documentTypes'],
        }),
        draftStatuses: build.query<DraftStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await draftStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['draftStatuses'],
        }),
        financialBillingStatuses: build.query<FinancialStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await financialBillingStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['financialBillingStatuses'],
        }),
        financialPaymentStatuses: build.query<FinancialStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await financialPaymentStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['financialPaymentStatuses'],
        }),
        financialInvoiceLineOfBusinesses: build.query<
            FinancialInvoiceLineOfBusinessesAPI,
            void
        >({
            queryFn: async () => {
                try {
                    const data = await financialInvoiceLineOfBusinesses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['financialInvoiceLineOfBusinesses'],
        }),
        financialSalesOrderLineOfBusinesses: build.query<
            FinancialSalesOrderLineOfBusinessesAPI,
            void
        >({
            queryFn: async () => {
                try {
                    const data = await financialSalesOrderLineOfBusinesses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['financialSalesOrderLineOfBusinesses'],
        }),
        financialStatuses: build.query<FinancialStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await financialStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['financialStatuses'],
        }),
        financialSyncQueueModels: build.query<
            FinancialSyncQueueModelAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await financialSyncQueueModels();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['financialSyncQueueModels'],
        }),
        financialSyncQueueResolveReasons: build.query<
            FinancialSyncQueueResolveReasonsAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await financialSyncQueueResolveReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['financialSyncQueueResolveReasons'],
        }),
        financialSyncQueueStatuses: build.query<
            FinancialSyncQueueStatusAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await financialSyncQueueStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['financialSyncQueueStatuses'],
        }),
        financialTerms: build.query<FinancialTermAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await financialTerms();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['financialTerms'],
        }),
        folderAttachmentTypes: build.query<FolderAttachmentTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await folderAttachmentTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['folderAttachmentTypes'],
        }),
        adjustmentTypes: build.query<AdjustmentTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await adjustmentTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['adjustmentTypes'],
        }),
        lineItemAdjustmentReasonTypes: build.query<
            LineItemAdjustmentReasonTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await lineItemAdjustmentReasonTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['lineItemAdjustmentReasonTypes'],
        }),
        lineItemStatuses: build.query<LineItemStatusesAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await lineItemStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['lineItemStatuses'],
        }),
        LaborWarrantyExtensionStatuses: build.query<
            LaborWarrantyExtensionStatusesAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await laborWarrantyExtensionStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['laborWarrantyExtensionStatuses'],
        }),
        managedProductCategories: build.query<
            ManagedProductCategoryAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await managedProductCategories();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['managedProductCategories'],
        }),
        managedProductAttributeTypes: build.query<
            ManagedProductAttributeTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await managedProductAttributeTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['managedProductAttributeTypes'],
        }),
        managedProductPricingTypes: build.query<
            ManagedProductPricingTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await managedProductPricingTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['managedProductPricingTypes'],
        }),
        managedVendorDistributionTypes: build.query<
            ManagedVendorDistributionTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await managedVendorDistributionTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['managedVendorDistributionTypes'],
        }),
        managedVendorIntegrationTypes: build.query<
            ManagedVendorIntegrationTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await managedVendorIntegrationTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['managedVendorIntegrationTypes'],
        }),
        managedVendorStatuses: build.query<ManagedVendorStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await managedVendorStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['managedVendorStatuses'],
        }),
        managedVendorTypes: build.query<ManagedVendorTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await managedVendorTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['managedVendorTypes'],
        }),
        opsAccounts: build.query<OpsAccountAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await opsAccounts();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['opsAccounts'],
        }),
        orderCancelReasons: build.query<OrderContactTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderCancelReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderCancelReasons'],
        }),
        orderContactTypes: build.query<OrderContactTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderContactTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderContactTypes'],
        }),
        orderFulfillmentMethods: build.query<orderFulfillmentMethodAPI[], void>(
            {
                queryFn: async () => {
                    try {
                        let data = [];
                        if (isMotiliAccount() || isClientAccount()) {
                            data = await orderFulfillmentMethods();
                        }
                        return { data };
                    } catch (error: any) {
                        const rtkError = createRTKError(error);
                        logger.error(rtkError);
                        return { error: rtkError };
                    }
                },
                providesTags: ['orderFulfillmentMethods'],
            }
        ),
        orderFulfillmentTypes: build.query<OrderFulfillmentTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderFulfillmentTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderFulfillmentTypes'],
        }),
        orderHoldReasons: build.query<OrderFulfillmentTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderHoldReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderHoldReasons'],
        }),
        orderIssues: build.query<OrderIssueAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderIssues();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderIssues'],
        }),
        orderLogisticsTypes: build.query<OrderLogisticsTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderLogisticsTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderLogisticsTypes'],
        }),
        orderNotificationTypes: build.query<OrderNotificationTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderNotificationTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderNotificationTypes'],
        }),
        orderManualVendorDetailTypes: build.query<
            OrderManualVendorDetailTypesApi[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await orderManualVendorDetailTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderManualVendorDetailTypes'],
        }),
        orderReturnCancelReasons: build.query<
            OrderReturnCancelReasonApi[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await orderReturnCancelReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderReturnCancelReasons'],
        }),
        orderReturnAttachmentTypes: build.query<
            OrderReturnAttachmentTypeApi[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await orderReturnAttachmentTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderReturnAttachmentTypes'],
        }),
        orderReturnContactTypes: build.query<OrderReturnContactTypeApi[], void>(
            {
                queryFn: async () => {
                    try {
                        const data = await orderReturnContactTypes();
                        return { data };
                    } catch (error: any) {
                        const rtkError = createRTKError(error);
                        logger.error(rtkError);
                        return { error: rtkError };
                    }
                },
                providesTags: ['orderReturnContactTypes'],
            }
        ),
        orderReturnReasons: build.query<OrderReturnReasonApi[], void>({
            queryFn: async () => {
                try {
                    const data = await orderReturnReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderReturnReasons'],
        }),
        orderReturnStatuses: build.query<OrderReturnStatusApi[], void>({
            queryFn: async () => {
                try {
                    const data = await orderReturnStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderReturnStatuses'],
        }),
        orderStatuses: build.query<OrderStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderStatuses'],
        }),
        orderPriorityTypes: build.query<OrderPriorityTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderPriorityTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderPriorityTypes'],
        }),
        orderTypes: build.query<OrderTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await orderTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['orderTypes'],
        }),
        priceBookTypes: build.query<PriceBookTypesAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await priceBookTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['priceBookTypes'],
        }),
        productAttributeTypes: build.query<ProductAttributeTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await productAttributeTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['productAttributeTypes'],
        }),
        productCategories: build.query<ProductCategoryAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await productCategories();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['productCategories'],
        }),
        projectAttachmentTypes: build.query<ProjectAttachmentTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await projectAttachmentTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['projectAttachmentTypes'],
        }),
        projectContactTypes: build.query<ProjectContactTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await projectContactTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['projectContactTypes'],
        }),
        projectHoldReasonTypes: build.query<ProjectHoldReasonTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await projectHoldReasonTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['projectHoldReasonTypes'],
        }),
        projects: build.query<ProjectAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await projects();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['projectScopeTypes'],
        }),
        projectScopeTypes: build.query<ProjectScopeTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await projectScopeTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['projectScopeTypes'],
        }),
        projectStatuses: build.query<ProjectStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await projectStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['projectStatuses'],
        }),
        projectTypes: build.query<ProjectTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await projectTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['projectTypes'],
        }),
        propertyAttachmentTypes: build.query<PropertyAttachmentTypeAPI[], void>(
            {
                queryFn: async () => {
                    try {
                        const data = await propertyAttachmentTypes();
                        return { data };
                    } catch (error: any) {
                        const rtkError = createRTKError(error);
                        logger.error(rtkError);
                        return { error: rtkError };
                    }
                },
                providesTags: ['propertyAttachmentTypes'],
            }
        ),
        propertyStatuses: build.query<PropertyStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await propertyStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['propertyStatuses'],
        }),
        propertyTypes: build.query<PropertyTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await propertyTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['propertyTypes'],
        }),
        quotePdfTypes: build.query<QuotePDFTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await quotePdfTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['quotePdfTypes'],
        }),
        quoteReopenReasons: build.query<QuoteReopenReasonsAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await quoteReopenReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['quoteReopenReasons'],
        }),
        quoteRequestRevisionTypes: build.query<
            QuoteRequestRevisionTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await quoteRequestRevisionTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['quoteRequestRevisionTypes'],
        }),
        quoteRejectTypes: build.query<QuoteRejectTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await quoteRejectTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['quoteRejectTypes'],
        }),
        quoteIssues: build.query<QuoteIssueAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await quoteIssues();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['quoteIssues'],
        }),
        quoteReasons: build.query<QuoteReasonsAPI, void>({
            queryFn: async () => {
                try {
                    const data = await quoteReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['quoteReasons'],
        }),
        quoteStatuses: build.query<QuoteStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await quoteStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['quoteStatuses'],
        }),
        quoteTypes: build.query<QuoteTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await quoteTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['quoteTypes'],
        }),
        savedOrderVisibilityTypes: build.query<
            SavedOrderVisibilityTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await savedOrderVisibilityTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['savedOrderVisibilityTypes'],
        }),
        states: build.query<StateAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await states();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['states'],
        }),
        templateTypes: build.query<TemplateTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await templateTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['templateTypes'],
        }),
        ticketProviders: build.query<TicketProviderAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await ticketProviders();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['ticketProviders'],
        }),
        timezones: build.query<TimezoneAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await timezones();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['timezones'],
        }),
        tsmRegions: build.query<TSM_Regions_API[], void>({
            queryFn: async () => {
                try {
                    const data = await tsmRegions();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['tsmRegions'],
        }),
        unitOfMeasures: build.query<UnitsofMeasureAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await unitOfMeasures();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['unitOfMeasures'],
        }),
        userAndGroupMentionsList: build.query<UserMention[], void>({
            queryFn: async () => {
                let data;
                try {
                    if (!isMotiliAccount()) {
                        return { data: [] };
                    }
                    data = await getUserAndGroupMentionslist();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['userAndGroupMentionsList'],
        }),
        usStates: build.query<StateAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await usStates();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['usStates'],
        }),
        vendorsAll: build.query<VendorAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await vendorsAll();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['vendorsAll'],
        }),
        vendorsApproved: build.query<VendorAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await vendorsApproved();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['vendorsApproved'],
        }),
        vendorManufacturers: build.query<VendorAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await vendorManufacturers();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['vendorManufacturers'],
        }),
        warrantyContactTypes: build.query<WarrantyContactTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await warrantyContactTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['warrantyContactTypes'],
        }),
        warrantyOwnerTypes: build.query<WarrantyOwnerTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await warrantyOwnerTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['warrantyOwnerTypes'],
        }),
        warrantyOwnerInstallTypes: build.query<
            WarrantyOwnerInstallTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await warrantyOwnerInstallTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['warrantyOwnerInstallTypes'],
        }),
        warrantyRegistrationStatuses: build.query<
            WarrantyRegistrationStatusesAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await warrantyRegistrationStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['warrantyRegistrationStatuses'],
        }),
        workOrderCheckInCheckOutReasons: build.query<
            WorkOrderCheckInCheckOutReasonTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await workOrderCheckInCheckOutReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderCheckInCheckOutReasons'],
        }),
        workOrderContactPreferenceTypes: build.query<
            WorkOrderContactPreferenceTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await workOrderContactPreferenceTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderContactPreferenceTypes'],
        }),
        workOrderContactTypes: build.query<WorkOrderContactTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await workOrderContactTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderContactTypes'],
        }),
        workOrderIssueRejectedTypes: build.query<
            WorkOrderIssueRejectedTypeAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await workOrderIssueRejectedTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderIssueRejectedTypes'],
        }),
        workOrderIssues: build.query<WorkOrderIssueAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await workOrderIssues();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderIssues'],
        }),
        workOrderPdfTypes: build.query<WorkOrderPDFTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await workOrderPdfTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderPdfTypes'],
        }),
        workOrderPhotoTypes: build.query<WorkOrderPhotoTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await workOrderPhotoTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderPhotoTypes'],
        }),
        workOrderVideoTypes: build.query<WorkOrderPhotoTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await workOrderVideoTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderVideoTypes'],
        }),
        workOrderPriorityTypes: build.query<WorkOrderPriorityTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await workOrderPriorityTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderPriorityTypes'],
        }),
        workOrderRequirementApprovalReasons: build.query<
            WorkOrderRequirementApprovalReasonAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await workOrderRequirementApprovalReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderRequirementApprovalReasons'],
        }),
        workOrderStatuses: build.query<WorkOrderStatusAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await workOrderStatuses();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderStatuses'],
        }),
        workOrderTypes: build.query<WorkOrderTypeAPI[], void>({
            queryFn: async () => {
                try {
                    const data = await workOrderTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderTypes'],
        }),
        lhsRiskTypes: build.query<LHSRiskType[], void>({
            queryFn: async () => {
                try {
                    const data = await lhsRiskTypes();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['lhsRiskTypes'],
        }),
        workOrderReassignReasons: build.query<
            WorkOrderReassignmentReasonAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await workOrderReassignReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderReassignReasons'],
        }),
        workOrderUnassignReasons: build.query<
            WorkOrderUnassignReasonAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await workOrderUnassignReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderUnassignReasons'],
        }),
        workOrderRescheduleReasons: build.query<
            WorkOrderRescheduleReasonAPI[],
            void
        >({
            queryFn: async () => {
                try {
                    const data = await workOrderRescheduleReasons();
                    return { data };
                } catch (error: any) {
                    const rtkError = createRTKError(error);
                    logger.error(rtkError);
                    return { error: rtkError };
                }
            },
            providesTags: ['workOrderRescheduleReasons'],
        }),
    }),
});

export const {
    useAccountRolesQuery,
    useAccountDepartmentAssignmentTypesQuery,
    useAccountDepartmentTypesQuery,
    useAccountPreferenceTypesQuery,
    useAccountRoleTypesQuery,
    useAccountTypesQuery,
    useActiveAssetConfigurationsQuery,
    useAssetConfigurationsQuery,
    useAssetConfigurationCategoriesQuery,
    useAssetManufacturersQuery,
    useAssetPhotoTypesQuery,
    useAssetRecommendationTypesQuery,
    useAssetRepairReasonsQuery,
    useAssetRetirementReasonsQuery,
    useAssetStatusesQuery,
    useAssetUntaggableReasonsQuery,
    useClientBusinessChannelsQuery,
    useClientsQuery,
    useClientFreightTypesQuery,
    useClientIntegrationTypesQuery,
    useClientOrderIssuesQuery,
    useClientStatusChangedNotificationConfigQuery,
    useClientSettingsQuery,
    useClientSettingByIdQuery,
    useClientStatusesQuery,
    useClientTradingServiceConstantsQuery,
    useContractorBlocklistReasonsQuery,
    useContractorCredentialsQuery,
    useContractorDispatchRuleTypesQuery,
    useContractorClientsQuery,
    useContractorExternalCertificationsQuery,
    useContractorInternalCertificationsQuery,
    useContractorFileTypesQuery,
    useContractorQualificationTypesQuery,
    useContractorServiceTypesQuery,
    useContractorStatusesQuery,
    useContractorTeamMemberFileTypesQuery,
    useContractorTeamMemberNotificationsQuery,
    useContractorTeamMemberTitlesQuery,
    useContractorJobTypeEligibilityTypesQuery,
    useCountriesQuery,
    useDirectedInvoiceTypesQuery,
    useDocumentTradeTypesQuery,
    useDocumentTypesQuery,
    useDraftStatusesQuery,
    useFinancialInvoiceLineOfBusinessesQuery,
    useFinancialSalesOrderLineOfBusinessesQuery,
    useFinancialStatusesQuery,
    useFinancialSyncQueueResolveReasonsQuery,
    useFinancialSyncQueueModelsQuery,
    useFinancialSyncQueueStatusesQuery,
    useFinancialTermsQuery,
    useFinancialBillingStatusesQuery,
    useFinancialPaymentStatusesQuery,
    useFolderAttachmentTypesQuery,
    useAdjustmentTypesQuery,
    useLineItemAdjustmentReasonTypesQuery,
    useLineItemStatusesQuery,
    useLaborWarrantyExtensionStatusesQuery,
    useManagedProductAttributeTypesQuery,
    useManagedProductPricingTypesQuery,
    useManagedVendorDistributionTypesQuery,
    useManagedVendorIntegrationTypesQuery,
    useManagedProductCategoriesQuery,
    useManagedVendorStatusesQuery,
    useManagedVendorTypesQuery,
    useOpsAccountsQuery,
    useOrderCancelReasonsQuery,
    useOrderContactTypesQuery,
    useOrderFulfillmentMethodsQuery,
    useOrderFulfillmentTypesQuery,
    useOrderHoldReasonsQuery,
    useOrderIssuesQuery,
    useOrderLogisticsTypesQuery,
    useOrderNotificationTypesQuery,
    useOrderManualVendorDetailTypesQuery,
    useOrderReturnCancelReasonsQuery,
    useOrderReturnAttachmentTypesQuery,
    useOrderReturnContactTypesQuery,
    useOrderReturnReasonsQuery,
    useOrderReturnStatusesQuery,
    useOrderPriorityTypesQuery,
    useOrderStatusesQuery,
    useOrderTypesQuery,
    usePriceBookTypesQuery,
    useProductAttributeTypesQuery,
    useProductCategoriesQuery,
    useProjectAttachmentTypesQuery,
    useProjectContactTypesQuery,
    useProjectHoldReasonTypesQuery,
    useProjectScopeTypesQuery,
    useProjectStatusesQuery,
    useProjectTypesQuery,
    usePropertyAttachmentTypesQuery,
    usePropertyStatusesQuery,
    usePropertyTypesQuery,
    useQuoteIssuesQuery,
    useQuotePdfTypesQuery,
    useQuoteReasonsQuery,
    useQuoteReopenReasonsQuery,
    useQuoteRequestRevisionTypesQuery,
    useQuoteRejectTypesQuery,
    useQuoteTypesQuery,
    useQuoteStatusesQuery,
    useUnitOfMeasuresQuery,
    useSavedOrderVisibilityTypesQuery,
    useStatesQuery,
    useTemplateTypesQuery,
    useTicketProvidersQuery,
    useTimezonesQuery,
    useTsmRegionsQuery,
    useVendorManufacturersQuery,
    useVendorsAllQuery,
    useVendorsApprovedQuery,
    useUserAndGroupMentionsListQuery,
    useUsStatesQuery,
    useWarrantyContactTypesQuery,
    useWarrantyOwnerTypesQuery,
    useWarrantyOwnerInstallTypesQuery,
    useWarrantyRegistrationStatusesQuery,
    useWorkOrderCheckInCheckOutReasonsQuery,
    useWorkOrderContactPreferenceTypesQuery,
    useWorkOrderContactTypesQuery,
    useWorkOrderIssuesQuery,
    useWorkOrderIssueRejectedTypesQuery,
    useWorkOrderPdfTypesQuery,
    useWorkOrderPhotoTypesQuery,
    useWorkOrderVideoTypesQuery,
    useWorkOrderPriorityTypesQuery,
    useWorkOrderRequirementApprovalReasonsQuery,
    useWorkOrderStatusesQuery,
    useWorkOrderTypesQuery,
    useLhsRiskTypesQuery,
    useWorkOrderReassignReasonsQuery,
    useWorkOrderUnassignReasonsQuery,
    useWorkOrderRescheduleReasonsQuery,
} = api;
export default api;
